export const getItemDiscount = (item) => {
  let amount = 0;
  let finalPrice;
  if (
    item.saleQuantity ||
    item.saleQuantity == "" ||
    item.saleQuantity == "0"
  ) {
    if (item.saleQuantity) {
      saleQty = item.saleQuantity;
      finalPrice = parseInt(itemPrice * item.saleQuantity);
    } else {
      saleQty = item.saleQuantity;
      finalPrice = parseInt(itemPrice * 1);
    }
  } else {
    saleQty = 1;
    finalPrice = parseInt(itemPrice * 1);
  }
  let itemDiscount = item.saleDiscount
    ? item.saleDiscount
    : item.saleDiscount == ""
    ? item.saleDiscount
    : item.discount;
  if (itemDiscount) {
    let eachValue = (itemDiscount / 100) * finalPrice;
    amount = Math.ceil(eachValue);
  } else if (itemDiscount == "") {
    amount = 0;
  } else {
    amount = 0;
  }
  console.log("amount:", amount);

  return amount;
};
